import { Component, Inject, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-cachingsettings',
  templateUrl: './cachingsettings.component.html',
  styleUrls: ['./cachingsettings.component.scss']
})
export class CachingSettingsComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
  buildingCache;
  trenchCache;
  ductCache;
  cableCache;
  rackCache;
  ngOnInit(): void {}
}
